import React, { useState, useEffect, useMemo } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import '../Relatorio/index.css';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Select from 'react-select';
import logo from '../../imagens/TSTRIPAS.png';

const Relatorio = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  // Estados dos modais
  const [showFinanceiroModal, setShowFinanceiroModal] = useState(false);
  const [showPedidoModal, setShowPedidoModal] = useState(false);
  const [showVendasModal, setShowVendasModal] = useState(false);
  const [showItemPedidoModal, setShowItemPedidoModal] = useState(false);
  const [showItemAgrupadoModal, setShowItemAgrupadoModal] = useState(false);

  // Estados de loading
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false);
  const [loadingPedido, setLoadingPedido] = useState(false);
  const [loadingItemPedido, setLoadingItemPedido] = useState(false);

  // Estados de dados
  const [financeiroData, setFinanceiroData] = useState([]);
  const [pedidoData, setPedidoData] = useState([]);
  const [itemPedidoData, setItemPedidoData] = useState([]);
  const [itemAgrupadoData, setItemAgrupadoData] = useState([]);
  const [clientes, setClientes] = useState([]);

  // Estados de filtros
  const hojeISO = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
  const [dataInicio, setDataInicio] = useState(hojeISO);
  const [dataFinal, setDataFinal] = useState(hojeISO);
  const [tipoData, setTipoData] = useState('cadastro');
  const [faturado, setFaturado] = useState(false);
  const [naoFaturado, setNaoFaturado] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState('');

  // Verificação de login
  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo?.alias};${userInfo?.venLogin}:${userInfo?.venSenha}`);

  // Buscar clientes
  useEffect(() => {
    const fetchClientes = async () => {
      if (!userInfo?.url) return;
      
      try {
        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        const text = await res.text();
        const safeText = text.replace(/\u00A0/g, ' ').trim();
        const json = JSON.parse(safeText);
        setClientes(json);
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      }
    };

    fetchClientes();
  }, [userInfo, credentials]);

  // Função para formatar data
  const formatarData = (dataISO) => {
    if (!dataISO) return '';
    const d = new Date(dataISO);
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  // Função para filtrar por data
  const filtrarPorData = (dados, tipo, inicio, final) => {
    return dados.filter(item => {
      let dataItem;
      
      switch(tipo) {
        case 'cadastro':
          dataItem = new Date(item.nfeDtaCadastro);
          break;
        case 'emissao':
          dataItem = new Date(item.nfeDtaEmissao);
          break;
        case 'entrega':
          dataItem = new Date(item.nfeDtaEntrega);
          break;
        default:
          dataItem = new Date(item.nfeDtaCadastro);
      }
      
      const dataInicio = new Date(inicio);
      const dataFinal = new Date(final);
      
      return dataItem >= dataInicio && dataItem <= dataFinal;
    });
  };

  // Dados filtrados com useMemo para cada tipo de relatório
  const pedidosFiltradosCompleto = useMemo(() => {
    if (!pedidoData.length) return [];
    return filtrarPorData(pedidoData, tipoData, dataInicio, dataFinal);
  }, [pedidoData, tipoData, dataInicio, dataFinal]);

  const itensPedidosFiltradosCompleto = useMemo(() => {
    if (!itemPedidoData.length) return [];
    return filtrarPorData(itemPedidoData, tipoData, dataInicio, dataFinal);
  }, [itemPedidoData, tipoData, dataInicio, dataFinal]);

  const itemAgrupadosFiltradosCompleto = useMemo(() => {
    if (!itemAgrupadoData.length) return [];
    return filtrarPorData(itemAgrupadoData, tipoData, dataInicio, dataFinal);
  }, [itemAgrupadoData, tipoData, dataInicio, dataFinal]);

  // Variáveis auxiliares
  const hoje = new Date().toLocaleDateString('pt-BR');

  const optionsClientes = clientes.map((cliente) => ({
    value: cliente.cliId,
    label: `${cliente.cliId} - ${cliente.colNome} (${cliente.colFantasia})`,
  }));

  // Handlers
  const handleClienteChange = (selectedOption) => {
    setClienteSelecionado(selectedOption?.value || '');
  };

  // Função para fechar modais
  const closeModals = () => {
    setShowFinanceiroModal(false);
    setShowPedidoModal(false);
    setShowVendasModal(false);
    setShowItemPedidoModal(false);
    setShowItemAgrupadoModal(false);
    setFinanceiroData([]);
    setPedidoData([]);
    setItemPedidoData([]);
    setItemAgrupadoData([]);
    setClienteSelecionado('');
  };

  // Funções para abrir modais e buscar dados
  const openFinanceiroModal = async () => {
    setShowFinanceiroModal(true);
    setFinanceiroData([]);
    setLoadingFinanceiro(true);

    try {
      const res = await fetch(`${userInfo.url}/receber/vendedor/${userInfo.ven_id}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);
      setFinanceiroData(json);
    } catch (err) {
      console.error('Erro ao buscar dados financeiros:', err);
    } finally {
      setLoadingFinanceiro(false);
    }
  };

  const openVendasModal = async () => {
    setShowVendasModal(true);
    setPedidoData([]);
    setItemPedidoData([]);
    setLoadingPedido(true);

    try {
      const [resPedidos, resItens] = await Promise.all([
        fetch(`${userInfo.url}/nfe`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
            'venId': userInfo.ven_id,
            'cliId': clienteSelecionado,
          }
        }),
        fetch(`${userInfo.url}/itemnfe`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
            'venId': userInfo.ven_id,
            'cliId': clienteSelecionado,
          }
        })
      ]);

      const textPedidos = await resPedidos.text();
      const safeTextPedidos = textPedidos.replace(/\u00A0/g, ' ').trim();
      const pedidosJson = JSON.parse(safeTextPedidos);

      const textItens = await resItens.text();
      const safeTextItens = textItens.replace(/\u00A0/g, ' ').trim();
      const itensJson = JSON.parse(safeTextItens);

      setPedidoData(pedidosJson);
      setItemPedidoData(itensJson);
    } catch (err) {
      console.error('Erro ao buscar dados de vendas:', err);
    } finally {
      setLoadingPedido(false);
    }
  };

  const openPedidoModal = async () => {
    setShowPedidoModal(true);
    setPedidoData([]);
    setLoadingPedido(true);

    try {
      const res = await fetch(`${userInfo.url}/nfe`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
          'venId': userInfo.ven_id,
          'cliId': clienteSelecionado,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);
      setPedidoData(json);
    } catch (err) {
      console.error('Erro ao buscar dados de pedidos:', err);
    } finally {
      setLoadingPedido(false);
    }
  };

  const openItemPedidoModal = async () => {
    setShowItemPedidoModal(true);
    setItemPedidoData([]);
    setLoadingItemPedido(true);
    
    try {
      const res = await fetch(`${userInfo.url}/itemnfe`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
          'venId': userInfo.ven_id,
          'cliId': clienteSelecionado,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);
      setItemPedidoData(json);
    } catch (err) {
      console.error('Erro ao buscar itens de pedidos:', err);
    } finally {
      setLoadingItemPedido(false);
    }
  };

  const openItemAgrupadoModal = async () => {
    setShowItemAgrupadoModal(true);
    setItemAgrupadoData([]);
    setLoadingItemPedido(true);

    try {
      const res = await fetch(`${userInfo.url}/itemnfe`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
          'venId': userInfo.ven_id,
          'cliId': clienteSelecionado,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);
      setItemAgrupadoData(json);
    } catch (err) {
      console.error('Erro ao buscar itens agrupados:', err);
    } finally {
      setLoadingItemPedido(false);
    }
  };

  // Filtros aplicados aos dados
  const pedidosFiltrados = pedidosFiltradosCompleto.filter(item => {
    if (faturado && (item.nfeStatus === 'Concluído' || item.nfeStatus === 'Autorizado')) return true;
    if (naoFaturado && (item.nfeStatus === 'Orçamento' || item.nfeStatus === 'Separado' || item.nfeStatus === 'Aguardando')) return true;
    if (!faturado && !naoFaturado) return true;
    return false;
  });

  const itensPedidosFiltrados = itensPedidosFiltradosCompleto.filter(item => {
    if (faturado && (item.nfeStatus === 'Concluído' || item.nfeStatus === 'Autorizado')) return true;
    if (naoFaturado && (item.nfeStatus === 'Orçamento' || item.nfeStatus === 'Separado' || item.nfeStatus === 'Aguardando')) return true;
    if (!faturado && !naoFaturado) return true;
    return false;
  });

  // Agrupamento de itens com dados já filtrados por data
  const itensAgrupados = itemAgrupadosFiltradosCompleto.reduce((acc, item) => {
    const cod = item.proCodInterno;
    if (!acc[cod]) {
      acc[cod] = {
        proCodInterno: item.proCodInterno,
        proDescricao: item.proDescricao,
        nfeStatus: item.nfeStatus,
        totalQtd: 0,
        totalVlr: 0
      };
    }
    acc[cod].totalQtd += Number(item.infeQtdProduto || 0);
    acc[cod].totalVlr += Number(item.total || 0);
    return acc;
  }, {});

  const itensAgrupadosArray = Object.values(itensAgrupados).sort((a, b) => b.totalQtd - a.totalQtd);

  const itensAgrupadosFiltrados = itensAgrupadosArray.filter(item => {
    if (faturado && (item.nfeStatus === 'Concluído' || item.nfeStatus === 'Autorizado')) return true;
    if (naoFaturado && (item.nfeStatus === 'Orçamento' || item.nfeStatus === 'Separado' || item.nfeStatus === 'Aguardando')) return true;
    if (!faturado && !naoFaturado) return true;
    return false;
  });

  // Cálculos de totais
  const totalFinanceiro = financeiroData.reduce((total, item) => {
    return total + Number(item.creVlrReceber || 0);
  }, 0);

  const totalPedido = pedidosFiltrados.reduce((total, item) => {
    return total + Number(item.nfeTotNota || 0);
  }, 0);

  const totalItemPedido = itensPedidosFiltrados.reduce((total, item) => {
    return total + Number(item.total || 0);
  }, 0);

  // Funções para gerar PDFs
  const gerarPDF = () => {
    const pdf = new jsPDF();
    pdf.text("Relatório Financeiro de Clientes Em Aberto", 50, 10);

    const tableColumn = ["Cliente","Pedido", "Título", "Parcela", "Pagamento", "Emissão", "Vencimento", "Valor"];
    const tableRows = financeiroData.map(item => [
      item.cliente,
      item.nfePedido,
      item.creTitulo,
      item.creParcela,
      item.crePagamento,
      formatarData(item.creDtaEmissao),
      formatarData(item.creDtaVencimento),
      `R$ ${item.creVlrReceber.toFixed(2)}`,
    ]);

    autoTable(pdf, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
      theme: 'grid',
    });

    const totalPages = pdf.internal.getNumberOfPages();
    pdf.setPage(totalPages);
    const finalY = pdf.lastAutoTable.finalY || 30;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const totalText = `Total: ${(totalFinanceiro ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}`;
    const textWidth = pdf.getTextWidth(totalText);
    const xPos = pageWidth - textWidth - 14;
    const yPos = finalY + 10;

    pdf.text(totalText, xPos, yPos);
    pdf.save(`Relatório-Financeiro-${hoje.replace(/\//g, '-')}`);
  };

    const gerarPDFVenda = () => {
    const pdf = new jsPDF();
    pdf.text("Relatório de Vendas", 80, 10);

    let currentY = 25;

    pedidosFiltrados.forEach((pedido, idx) => {
      // Cabeçalho do pedido
      pdf.setFontSize(10);
      pdf.text(`Cliente: ${pedido.colFantasia}`, 8, currentY);
      pdf.text(`Pedido: ${pedido.nfeId} | Nota: ${pedido.nfeNota} | Cadastro: ${formatarData(pedido.nfeDtaCadastro)} | Emissão: ${formatarData(pedido.nfeDtaEmissao)} | Status: ${pedido.nfeStatus} | Total Nota: R$ ${pedido.nfeTotNota}`, 8, currentY + 5);

      currentY += 12;

      // Itens do pedido
      const itensDoPedido = itensPedidosFiltrados.filter(item =>
        String(item.nfeId || item.infeNfeId || item.nfe_id) === String(pedido.nfeId)
      );

      if (itensDoPedido.length > 0) {
        autoTable(pdf, {
          head: [["Produto", "Quantidade", "Valor"]],
          body: itensDoPedido.map(item => [
            item.proDescricao,
            item.infeQtdProduto,
            `R$ ${item.infeVlrProduto}`
          ]),
          startY: currentY,
          styles: { fontSize: 8 },
          headStyles: { fillColor: [41, 128, 185] },
          theme: 'grid',
          margin: { left: 8, right: 8 },
        });
        currentY = pdf.lastAutoTable.finalY + 10;
      } else {
        currentY += 5;
      }

      // Adiciona espaço entre pedidos
      if (idx < pedidosFiltrados.length - 1) {
        pdf.line(8, currentY, pdf.internal.pageSize.getWidth() - 8, currentY);
        currentY += 5;
      }
    });

    // Total geral
    const totalText = `Total: ${(totalPedido ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}`;
    pdf.setFontSize(12);
    pdf.text(totalText, 8, currentY + 10);

    pdf.save(`Relatório-Pedido-${hoje.replace(/\//g, '-')}.pdf`);
  };

  const gerarPDFPedido = () => {
    const pdf = new jsPDF();
    pdf.text("Relatório de Pedidos", 80, 10);

    const tableColumn = [
      "Cliente", "Pedido", "Nota", "Cadastro", 
      "Emissão", "Status", "Total Produtos", "Total Nota"
    ];
    const tableRows = pedidosFiltrados.map(item => [
      item.colFantasia,
      item.nfeId,
      item.nfeNota,
      formatarData(item.nfeDtaCadastro),
      formatarData(item.nfeDtaEmissao),
      item.nfeStatus,
      `R$ ${item.nfeTotMercadoria}`,
      `R$ ${item.nfeTotNota}`,
    ]);

    autoTable(pdf, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
      theme: 'grid',
      margin: { top: 15, right: 5, bottom: 10, left: 5 },
    });

    const totalPages = pdf.internal.getNumberOfPages();
    pdf.setPage(totalPages);
    const finalY = pdf.lastAutoTable.finalY || 30;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const totalText = `Total: ${(totalPedido ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}`;
    const textWidth = pdf.getTextWidth(totalText);
    const xPos = pageWidth - textWidth - 8;
    const yPos = finalY + 10;

    pdf.text(totalText, xPos, yPos);
    pdf.save(`Relatório-Pedido-${hoje.replace(/\//g, '-')}`);
  };

  const imprimirBoleto = async (creId, cliId, cliente) => {
    try {

      // 6️⃣ Depois dispara o fetch para gerar o boleto
      await fetch(`${userInfo.url}/receber/boleto/impressao/${creId}`, {
        method: "GET",
        headers: { empresa: userInfo.alias },
      });

      // 1️⃣ Gera a URL do PDF
      const pdfUrl = `${userInfo.url}/pdf/${cliId}.pdf`;
      
      // 2️⃣ Fetch do PDF para download com nome personalizado
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      
      // 3️⃣ Cria URL do blob
      const url = window.URL.createObjectURL(blob);
      
      // 4️⃣ Download com nome personalizado
      const a = document.createElement('a');
      a.href = url;
      const agora = new Date();
      const dataHora = `${agora.getDate().toString().padStart(2, '0')}-${(agora.getMonth() + 1).toString().padStart(2, '0')}-${agora.getFullYear()}-${agora.getHours().toString().padStart(2, '0')}-${agora.getMinutes().toString().padStart(2, '0')}`;
      a.download = `Boleto-${cliente}-${dataHora}.pdf`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      
      // 5️⃣ Limpa a URL do blob
      window.URL.revokeObjectURL(url);
      
      
    } catch (err) {
      console.error(err);
      alert("Erro ao imprimir boleto");
    }
  };

  return (
    <>
      <header className="header">
        <img src={logo} alt="Logo" className="header-logo" />
        <h2>Bem-vindo, {userInfo?.username}!</h2>
        <h1>Relatórios {userInfo?.company}</h1>
      </header>

      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      <div className="Relatorios">
        {/* Relatório Financeiro */}
        <div className='relatorioFinanceiro'>
          <span>
            <strong>Relatório de clientes vencidos:</strong>
            <button onClick={openFinanceiroModal}>
              📊 Gerar Relatório De Títulos
            </button>
          </span>

          {showFinanceiroModal && (
            <div className="modal-relatorio">
              <div className="modal-content-relatorio">
                <h2>Relatório Financeiro Títulos Em Aberto</h2>

                {loadingFinanceiro && <p>Carregando...</p>}

                {!loadingFinanceiro && financeiroData.length > 0 ? (
                  <div>
                    <table className="financeiro-grid">
                      <thead>
                        <tr>
                          <th>Cliente</th>
                          <th>Pedido</th>
                          <th>Título</th>
                          <th>Parcela</th>
                          <th>Pagamento</th>
                          <th>Emissão</th>
                          <th>Vencimento</th>
                          <th>Valor</th>
                          <th>🖨️ Boleto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {financeiroData.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.cliente}</td>
                            <td>{item.nfePedido}</td>
                            <td>{item.creTitulo}</td>
                            <td>{item.creParcela}</td>
                            <td>{item.crePagamento}</td>
                            <td>{formatarData(item.creDtaEmissao)}</td>
                            <td>{formatarData(item.creDtaVencimento)}</td>
                            <td>R$ {item.creVlrReceber.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                            <td>{item.crePagamento === 'BOLETO' && (<button className='impBoleto' onClick={() => imprimirBoleto(item.creId, item.cliId, item.cliente)}>🧾</button>)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <span className='totalFinanceiro'>
                      <strong>Total:</strong> {((totalFinanceiro ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",}))}
                    </span>
                  </div>
                ) : !loadingFinanceiro && (
                  <p>❌ Nenhum registro encontrado</p>
                )}

                <button onClick={closeModals}>Fechar</button>
                <button className='btnPDF' onClick={gerarPDF}>🖨️ PDF</button>
              </div>
            </div>
          )}
        </div>

        {/* Filtros */}
        <div className="containerFiltros">
          <div className='relatorioFinanceiro'>
            <div className="filtros">
              <div className="filtros-relatorio">
                <div className='filtro-group '>
                  <label>Tipo:</label>
                  <select value={tipoData} onChange={e => setTipoData(e.target.value)}>
                    <option value="cadastro">Data de Cadastro</option>
                    <option value="emissao">Data de Emissão</option>
                    <option value="entrega">Data de Entrega</option>
                  </select>


                  <label>Início:</label>
                  <input type="date" value={dataInicio} onChange={e => setDataInicio(e.target.value)} />
                  

                  <label>Final:</label>
                  <input type="date" value={dataFinal} onChange={e => setDataFinal(e.target.value)} />
                
                </div> 

                <label>Cliente</label> 
                <Select
                  className="clientePedido"
                  options={optionsClientes}
                  onChange={handleClienteChange}
                  placeholder="Digite o nome do cliente..."
                  isClearable
                />
              
                <div className='filtro-group-pedido'>
                  <div className='filtro-group-select'>
                    <label>
                    <input type="checkbox" checked={naoFaturado} onChange={e => setNaoFaturado(e.target.checked)} />
                    Em Separação (Não Faturado)</label>
                  </div>

                  <div className='filtro-group-select'>
                    <label>
                    <input type="checkbox" checked={faturado} onChange={e => setFaturado(e.target.checked)} />
                    Faturados (Concluído)</label>
                  </div>
                </div>
              </div>
            </div>

            {/* Relatório de Vendas */}
            <div>
              <span>
                <div className='cabFiltros'>
                  <strong>Relatório de vendas (Pedidos com Itens):</strong>
                </div>
                <button onClick={openVendasModal}>
                  🧾 Gerar Relatório de vendas
                </button>
              </span>

              {showVendasModal && (
                <div className="modal-relatorio">
                  <div className="modal-content-relatorio">
                    <h2>Relatório de vendas (Pedidos com Itens)</h2>

                    {loadingPedido && <p>Carregando...</p>}

                    {!loadingPedido && (pedidosFiltrados.length > 0 ? (
                      <div>
                        {pedidosFiltrados.map((pedido, idx) => {
                          const itensDoPedido = itensPedidosFiltrados.filter(item => 
                            String(item.nfeId || item.infeNfeId || item.nfe_id) === String(pedido.nfeId)
                          );

                          return (
                            <div key={idx} className="pedido-bloco">
                              <table className="PedidoItens-grid">
                                <thead className='cabecalhoTabela'>
                                  <tr>
                                    <th>Cliente</th>
                                    <th>Pedido</th>
                                    <th>Nota</th>
                                    <th>Cadastro</th>
                                    <th>Emissão</th>
                                    <th>Status</th>
                                    <th>Total Nota</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{pedido.colFantasia}</td>
                                    <td>{pedido.nfeId}</td>
                                    <td>{pedido.nfeNota}</td>
                                    <td>{formatarData(pedido.nfeDtaCadastro) || ''}</td>
                                    <td>{formatarData(pedido.nfeDtaEmissao) || ''}</td>
                                    <td>{pedido.nfeStatus}</td>
                                    <td>{pedido.nfeTotNota.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                                  </tr>
                                </tbody>
                              </table>
                              
                              {/* Itens do pedido */}
                              {itensDoPedido.length > 0 && (
                                <table className="ItensPedido-grid">
                                  <thead>
                                    <tr>
                                      <th>Produto</th>
                                      <th>Quantidade</th>
                                      <th>Valor</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {itensDoPedido.map((item, iidx) => (
                                      <tr key={iidx}>
                                        <td>{item.proDescricao}</td>
                                        <td>{item.infeQtdProduto.toLocaleString("pt-BR")}</td>
                                        <td>{item.infeVlrProduto.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          );
                        })}
                        <span className='totalFinanceiro'>
                          <strong>Total:</strong> {(totalPedido ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}
                        </span>
                      </div>
                    ) : (
                      <p>❌ Nenhum registro encontrado</p>                 
                    ))}
                    
                    <button onClick={closeModals}>Fechar</button>
                    <button className='btnPDF' onClick={gerarPDFVenda}>🖨️ PDF</button>
                  </div>
                </div>
              )}
            </div>

            {/* Relatório de Pedidos */}
            <div>
              <span>
                <div className='cabFiltros'>
                  <strong>Resumo de Pedidos:</strong>
                </div>
                <button onClick={openPedidoModal}>
                  🧾 Gerar Resumo de Pedidos
                </button>
              </span>

              {showPedidoModal && (
                <div className="modal-relatorio">
                  <div className="modal-content-relatorio">
                    <h2>Resumo de Pedidos</h2>

                    {loadingPedido && <p>Carregando...</p>}

                    {!loadingPedido && (pedidoData.length > 0 ? (
                      <div>
                        <table className="ItensPedido-grid">
                          <thead>
                            <tr>
                              <th>Cliente</th>
                              <th>Pedido</th>
                              <th>Nota</th>
                              <th>Cadastro</th>
                              <th>Emissão</th>
                              <th>Status</th>
                              <th>Total Nota</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pedidosFiltrados.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.colFantasia}</td>
                                <td>{item.nfeId}</td>
                                <td>{item.nfeNota}</td>
                                <td>{formatarData(item.nfeDtaCadastro) || ''}</td>
                                <td>{formatarData(item.nfeDtaEmissao) || ''}</td>
                                <td>{item.nfeStatus}</td>
                                <td>{item.nfeTotNota.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <span className='totalFinanceiro'>
                          <strong>Total:</strong> {(totalPedido ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}
                        </span>
                      </div>
                    ) : (
                      <p>❌ Nenhum registro encontrado</p>                 
                    ))}
                    
                    <button onClick={closeModals}>Fechar</button>
                    <button className='btnPDF' onClick={gerarPDFPedido}>🖨️ PDF</button>
                  </div>
                </div>
              )}
            </div>

            {/* Relatório de Itens Vendidos */}
            <div>
              <span>
                <div className='cabFiltros'>
                  <strong>Relação de Itens Vendidos:</strong>
                </div>
                <button onClick={openItemPedidoModal}>
                  📦 Gerar Relação de Itens Vendidos
                </button>
              </span>

              {showItemPedidoModal && (
                <div className="modal-relatorio">
                  <div className="modal-content-relatorio">
                    <h2>Relação de Itens Vendidosl</h2>

                    {loadingItemPedido && <p>Carregando...</p>}

                    {!loadingItemPedido && (itensPedidosFiltrados.length > 0 ? (
                      <div>
                        <table className="ItensPedido-grid">
                          <thead>
                            <tr>
                              <th>Pedido</th>
                              <th>Data</th>
                              <th>ID Prod</th>
                              <th>Produto</th>
                              <th>Quantidade</th>
                              <th>Valor Unit</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {itensPedidosFiltrados.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.nfeId}</td>
                                <td>{formatarData(item.nfeDtaCadastro) || ''}</td>
                                <td>{item.proCodInterno}</td>
                                <td>{item.proDescricao}</td>
                                <td>{item.infeQtdProduto.toLocaleString("pt-BR")}</td>
                                <td>{(item.infeVlrProduto ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                                <td>{(item.total ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <span className='totalFinanceiro'>
                          <strong>Total:</strong> {(totalItemPedido ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}
                        </span>
                      </div>
                    ) : (
                      <p>❌ Nenhum registro encontrado</p>
                    ))}
                    
                    <button onClick={closeModals}>Fechar</button>
                  </div>
                </div>
              )}
            </div>

            {/* Relatório de Itens Agrupados */}
            <div>
              <span>
                <div className='cabFiltros'>
                  <strong>Resumo de Itens Vendidos (Agrupados):</strong>
                </div>
                <button onClick={openItemAgrupadoModal}>
                  📦 Resumo Agrupado por Produto
                </button>
              </span>

              {showItemAgrupadoModal && (
                <div className="modal-relatorio">
                  <div className="modal-content-relatorio">
                    <h2>Resumo de Itens Vendidos (Agrupado)</h2>

                    {loadingItemPedido && <p>Carregando...</p>}

                    {!loadingItemPedido && itensAgrupadosArray.length > 0 ? (
                      <div>
                        <table className="ItensPedido-grid">
                          <thead>
                            <tr>
                              <th>ID Prod</th>
                              <th>Produto</th>
                              <th>Total Qtd</th>
                              <th>Total Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            {itensAgrupadosFiltrados.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.proCodInterno}</td>
                                <td>{item.proDescricao}</td>
                                <td>{item.totalQtd.toLocaleString("pt-BR")}</td>
                                <td>{item.totalVlr.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <span className="totalFinanceiro">
                          <strong>Total Geral:</strong> {(itensAgrupadosFiltrados
                            .reduce((sum, i) => sum + i.totalVlr, 0)
                             ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}
                        </span>
                      </div>
                    ) : (
                      <p>❌ Nenhum registro encontrado</p>
                    )}

                    <button onClick={closeModals}>Fechar</button>
                    
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Relatorio;